
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {
  ModulDugumu,
  ModulYetkiSatiri,
  UrunGrubu,
  YetkiKademe,
  kademeEnAz,
  modulIkonu,
} from "@/enum/YetkiModulleri";
import KademeSecici from "@/components/izinler/KademeSecici.vue";
import IslemSecici from "@/components/izinler/IslemSecici.vue";
import {DuzDugum, duzDugumler, gosterimAgaciKur} from "@/components/izinler/modulAgaci";
import {
  BAYRAKLAR,
  Hucre,
  SatirPayload,
  gizliBayrakIpucu,
  hucreNormalle,
  kademeSonrasiHucre,
  kisiDegeriVarMi,
  kisiHucresiNormalle,
  ozelIpucu,
  roldenGelsin,
  saklananAyniMi,
  satirDegistiMi,
  satirPayload,
} from "@/components/izinler/kisiOzelYetki";
import {UstHaritasi, kural1Kilidi, kural1Uygula, ustHaritasiKur} from "@/components/izinler/kural1";

@Component({
  components: {KademeSecici, IslemSecici},
})
export default class KisiOzelYetkiDialog extends Vue {
  // v-model: diyaloğun açık/kapalı durumu.
  @Prop({type: Boolean, default: false}) value!: boolean;
  @Prop({type: Number, default: null}) kisiId!: number | null;
  @Prop({type: String, default: ""}) kisiAdi!: string;
  // Kişinin rolleri ({id, name}); başlıkta gösterilir. Kişi listesi ucu rolleri adıyla döndürür.
  @Prop({type: Array, default: () => []}) roller!: Array<{ id: number; name: string }>;
  // DEV-2113 kısıtlı dönem: yalnız görüntüleme.
  @Prop({type: Boolean, default: false}) saltOkunur!: boolean;

  yukleniyor = false;
  yuklemeHatasi = false;
  kaydediliyor = false;
  // Her yükleme çağrısına artan numara: yalnız en son çağrının sonucu yazılır (kişi hızlı değişirse).
  yuklemeNo = 0;

  // Gösterim ağacı (matrisle aynı kurucu) ve modül başına durum.
  agac: UrunGrubu[] = [];
  // modul -> KademeSecici/IslemSecici'nin düzenlediği satır (etkin değerle başlar).
  satirlar: { [modul: string]: ModulYetkiSatiri } = {};
  // modul -> rol hücresi (kişi satırı hariç): "özel mi" karşılaştırmasının tabanı.
  rolHucreleri: { [modul: string]: Hucre } = {};
  // modul -> açılıştaki etkin hücre: değiştirilmeyen satırın saklı değeri olduğu gibi kalır.
  ilkHucreler: { [modul: string]: Hucre } = {};
  // modul -> sunucudaki saklı kişi satırı (null = rolden gelsin). "Özel mi" kararı ve PUT'un tabanı; sunucunun
  // ozel_yetki_sayisi'yla aynı kaynak. Etkin hücreyle rolü karşılaştırmak, rolle aynı değeri saklayan satırı kaçırır.
  kisiHucreleri: { [modul: string]: SatirPayload } = {};
  // "Rolden gelsin" basılan modüller: etkin değer değişmese de saklı satır temizlenir.
  sifirlananlar: { [modul: string]: boolean } = {};

  // Accordion (yalnız gösterim): ürün grupları varsayılan AÇIK, alt başlıklı düğümler KAPALI.
  acikGruplar: { [urun: string]: boolean } = {};
  acikDugumler: { [modul: string]: boolean } = {};

  get acik(): boolean {
    return this.value;
  }

  set acik(deger: boolean) {
    this.$emit("input", deger);
  }

  get duzenlemeKapali(): boolean {
    return this.saltOkunur || this.kaydediliyor;
  }

  // Açık diyaloğun kişisi (kapalıyken null): açılışta ve açıkken kişi değişirse o kişiden yüklenir.
  get acikKisiId(): number | null {
    return this.value && this.kisiId !== null ? this.kisiId : null;
  }

  @Watch("acikKisiId", {immediate: true})
  onAcikKisi(kisiId: number | null) {
    if (kisiId !== null) {
      this.yukle();
    }
  }

  async yukle() {
    const no = ++this.yuklemeNo;
    this.yukleniyor = true;
    this.yuklemeHatasi = false;
    this.agac = [];
    this.satirlar = {};
    try {
      const response: any = await this.$http.get(`/api/v1/yetki/kisiler/${this.kisiId}/modul-yetkileri`);
      if (no !== this.yuklemeNo) {
        return;
      }
      const veri = response.data && response.data.data ? response.data.data : response.data;
      this.kur((veri && veri.yetkiler) || []);
    } catch (hata) {
      // Hatadan gelen boş sonuç gerçek veri gibi kullanılamaz: görünüm kapanır, kaydedilemez.
      if (no === this.yuklemeNo) {
        this.yuklemeHatasi = true;
      }
    } finally {
      if (no === this.yuklemeNo) {
        this.yukleniyor = false;
      }
    }
  }

  // Sunucu satırlarından (modül başına {modul, rol_hucresi, kisi_hucresi, etkin_hucre}) ekran
  // durumunu kurar. Satır kümesi sunucudan gelir; sıra/etiket/gruplama kanonik ağaçtan.
  kur(yetkiler: any[]) {
    const satirlar: { [modul: string]: ModulYetkiSatiri } = {};
    const rolHucreleri: { [modul: string]: Hucre } = {};
    const ilkHucreler: { [modul: string]: Hucre } = {};
    const kisiHucreleri: { [modul: string]: SatirPayload } = {};
    const urunHaritasi: { [modul: string]: string | null } = {};
    const etiketHaritasi: { [modul: string]: string | null } = {};

    yetkiler.forEach((y: any) => {
      const etkin = hucreNormalle(y.etkin_hucre);
      rolHucreleri[y.modul] = hucreNormalle(y.rol_hucresi);
      ilkHucreler[y.modul] = {...etkin};
      kisiHucreleri[y.modul] = kisiHucresiNormalle(y.kisi_hucresi);
      urunHaritasi[y.modul] = y.urun ?? null;
      etiketHaritasi[y.modul] = y.etiket ?? null;
      satirlar[y.modul] = {
        modul: y.modul,
        kademe: etkin.kademe,
        ekle: etkin.ekle,
        degistir: etkin.degistir,
        sil: etkin.sil,
        urun: y.urun ?? null,
        // Aile bağı yalnız sunucunun `ust`'u (null dahil); ekran ağacının iç içeliği aile değildir (kural1.ts).
        ust: y.ust ?? null,
      };
    });

    this.satirlar = satirlar;
    this.rolHucreleri = rolHucreleri;
    this.ilkHucreler = ilkHucreler;
    this.kisiHucreleri = kisiHucreleri;
    this.sifirlananlar = {};
    this.agac = gosterimAgaciKur(Object.keys(satirlar), urunHaritasi, etiketHaritasi);

    // Kişiye özel satırlar kapalı bir alt başlığın içinde kalıp gözden kaçmasın: ataları açık başlar.
    const acik: { [modul: string]: boolean } = {};
    this.agac.forEach((grup) => {
      duzDugumler(grup.dugumler).forEach((node) => {
        if (this.satirOzel(node.dugum.modul)) {
          node.ustZinciri.forEach((ust) => {
            acik[ust] = true;
          });
        }
      });
    });
    this.acikGruplar = {};
    this.acikDugumler = acik;
  }

  duzDugumler(dugumler: ModulDugumu[]): DuzDugum[] {
    return duzDugumler(dugumler);
  }

  dugumGorunur(node: DuzDugum): boolean {
    return node.ustZinciri.every((modul) => this.dugumAcik(modul));
  }

  modulIkonu(modul: string): string {
    return modulIkonu(modul);
  }

  grupAcik(urun: string): boolean {
    return this.acikGruplar[urun] !== false;
  }

  grupToggle(urun: string) {
    this.$set(this.acikGruplar, urun, !this.grupAcik(urun));
  }

  dugumAcik(modul: string): boolean {
    return this.acikDugumler[modul] === true;
  }

  dugumToggle(modul: string) {
    this.$set(this.acikDugumler, modul, !this.dugumAcik(modul));
  }

  grupModulSayisi(grup: UrunGrubu): number {
    const say = (dugumler: ModulDugumu[]): number =>
      dugumler.reduce((toplam, d) => toplam + 1 + say(d.cocuklar || []), 0);
    return say(grup.dugumler);
  }

  // Satırın o anki değeri (KademeSecici/IslemSecici'nin düzenlediği satırdan).
  hucre(modul: string): Hucre {
    const s = this.satirlar[modul];
    return {kademe: s.kademe, ekle: !!s.ekle, degistir: !!s.degistir, sil: !!s.sil};
  }

  // Kayıttan sonra saklanacak kişi satırı: dokunulmayan satır sunucudaki gibi kalır; değiştirilen ya da
  // "Rolden gelsin" basılan satırda role eşit alan null olur.
  saklanacak(modul: string): SatirPayload {
    const rol = this.rolHucreleri[modul];
    const hucre = this.hucre(modul);
    if (this.sifirlananlar[modul] || satirDegistiMi(hucre, this.ilkHucreler[modul])) {
      return satirPayload(hucre, rol);
    }
    return this.kisiHucreleri[modul] || kisiHucresiNormalle(null);
  }

  satirOzel(modul: string): boolean {
    return !!this.rolHucreleri[modul] && !!this.satirlar[modul] && kisiDegeriVarMi(this.saklanacak(modul));
  }

  get ozelModulSayisi(): number {
    return Object.keys(this.satirlar).filter((modul) => this.satirOzel(modul)).length;
  }

  kademeIsareti(modul: string): string {
    const rol = this.rolHucreleri[modul];
    const saklanacak = this.saklanacak(modul);
    return rol && saklanacak.kademe !== null ? ozelIpucu("kademe", rol, saklanacak) : "";
  }

  // Bayrak işareti yalnız Düzenle'de (işlem düğmeleri yalnız orada anlamlı).
  islemIsaretleri(modul: string): { [alan: string]: string } {
    const rol = this.rolHucreleri[modul];
    const sonuc: { [alan: string]: string } = {};
    if (!rol || this.hucre(modul).kademe !== YetkiKademe.DUZENLE) {
      return sonuc;
    }
    const saklanacak = this.saklanacak(modul);
    BAYRAKLAR.forEach((alan) => {
      if (saklanacak[alan] !== null) {
        sonuc[alan] = ozelIpucu(alan, rol, saklanacak);
      }
    });
    return sonuc;
  }

  // Sayaçtaki her satır ekranda işaretli olsun: alan işareti çizilmeyen kişiye özel satır (Düzenle dışı kademede saklı
  // bayrak) işaretini modül adının yanında taşır.
  satirIsareti(modul: string): string {
    if (!this.satirOzel(modul) || this.kademeIsareti(modul) || Object.keys(this.islemIsaretleri(modul)).length > 0) {
      return "";
    }
    return gizliBayrakIpucu(this.saklanacak(modul)) || "Bu kullanıcıya özel";
  }

  // DEV-2684 bağımlılık ailesi ve Kural 1: matris ve geçiş ekranıyla aynı kaynak (kural1.ts).
  get ustHaritasi(): UstHaritasi {
    return ustHaritasiKur(this.satirlar);
  }

  kademeKilidi(modul: string): YetkiKademe | null {
    return kural1Kilidi(modul, this.satirlar, this.ustHaritasi);
  }

  // Kademe değişince: bayraklar matristeki gibi ayarlanır, sonra Kural 1 üst yükseltmesi.
  kademeDegisti(modul: string) {
    const satir = this.satirlar[modul];
    if (!satir) {
      return;
    }
    Object.assign(satir, kademeSonrasiHucre(this.hucre(modul), this.rolHucreleri[modul]));
    kural1Uygula(this.satirlar, this.ustHaritasi);
  }

  // Rol değerine dönmek Kural 1'i bozuyorsa (alt başlık açıkken üst rolde daha düşük) dönülemez.
  sifirlanabilir(modul: string): boolean {
    const kilit = this.kademeKilidi(modul);
    return !kilit || kademeEnAz(this.rolHucreleri[modul].kademe, kilit);
  }

  sifirla(modul: string) {
    if (!this.sifirlanabilir(modul)) {
      return;
    }
    Object.assign(this.satirlar[modul], roldenGelsin(this.rolHucreleri[modul]));
    this.$set(this.sifirlananlar, modul, true);
    // Rol değeri alt başlığı açabilir; kişiye özel kapalı üst kademeDegisti'deki gibi yükselir.
    kural1Uygula(this.satirlar, this.ustHaritasi);
  }

  kapat() {
    this.acik = false;
  }

  async kaydet() {
    if (this.saltOkunur || this.yukleniyor || this.yuklemeHatasi || this.kaydediliyor) {
      return;
    }
    // Yalnız saklı değeri değişecek satırlar gider; "Rolden gelsin" etkin değer aynı kalsa da satırı temizler.
    const degisenler = Object.keys(this.satirlar)
        .filter((modul) => !saklananAyniMi(this.saklanacak(modul), this.kisiHucreleri[modul] || kisiHucresiNormalle(null)));
    if (degisenler.length === 0) {
      this.kapat();
      return;
    }
    // Role eşit alan null gider (rolden gelsin); tüm alanları null olan satır sunucuda kişi satırı olmaktan çıkar.
    const yetkiler = degisenler.map((modul) => ({modul, ...this.saklanacak(modul)}));
    this.kaydediliyor = true;
    try {
      await this.$http.put(`/api/v1/yetki/kisiler/${this.kisiId}/modul-yetkileri`, {yetkiler});
      this.$toast.success("Kişiye özel yetkiler kaydedildi.");
      this.$emit("kaydedildi", this.kisiId);
      this.kapat();
    } catch (hata) {
      // 403/409/422 mesajları matris ekranındaki gibi global axios kesicisinde gösterilir; diyalog açık kalır.
    } finally {
      this.kaydediliyor = false;
    }
  }
}
